class CoupleCratePersonalize extends HTMLElement {
  connectedCallback() {
    this.variantInput = this.querySelector('[data-cc-variant-input]');
    this.priceOut = this.querySelector('[data-cc-price-out]');
    this.colorsSelect = this.querySelector('[data-cc-colors-select]');
    this.colorSlots = [...this.querySelectorAll('[data-cc-color-slot]')];
    this.shellInputs = [...this.querySelectorAll('[data-cc-shell]')];
    this.shellHiddenInput = this.querySelector('[data-cc-shell-input]');
    this.shellMax = Number(this.dataset.shellMax || 3);
    this.nameInputs = [...this.querySelectorAll('[data-cc-name]')];
    this.summary = this.querySelector('[data-cc-summary]');
    this.galleryMain = this.querySelector('[data-cc-gallery-main]');
    this.thumbs = [...this.querySelectorAll('[data-cc-thumb]')];

    this.colorsSelect?.addEventListener('change', () => this.#onColorsCountChange());
    this.colorSlots.forEach((slot) => {
      slot.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          this.#syncColorExclusion();
          this.#updateSummary();
        });
      });
    });
    this.shellInputs.forEach((input) => input.addEventListener('change', () => this.#onShellChange(input)));
    this.nameInputs.forEach((input) => input.addEventListener('input', () => this.#onNameInput(input)));
    this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.#onThumbClick(thumb)));

    this.#onColorsCountChange();
    this.#updateSummary();
  }

  #onColorsCountChange() {
    if (!this.colorsSelect) return;
    const option = this.colorsSelect.selectedOptions[0];
    const variantId = option?.dataset.variantId;
    const price = option?.dataset.price;
    const count = Number(option?.dataset.count || 2);

    if (variantId && this.variantInput) this.variantInput.value = variantId;
    if (price && this.priceOut) this.priceOut.textContent = price;

    this.colorSlots.forEach((slot) => {
      const index = Number(slot.dataset.ccColorSlot);
      const active = index <= count;
      slot.hidden = !active;
      slot.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.disabled = !active;
        if (!active) radio.checked = false;
      });
    });

    this.#syncColorExclusion();
    this.#updateSummary();
  }

  #syncColorExclusion() {
    const visibleSlots = this.colorSlots.filter((slot) => !slot.hidden);
    const chosen = visibleSlots
      .map((slot) => slot.querySelector('input[type="radio"]:checked'))
      .filter(Boolean)
      .map((input) => input.value);

    visibleSlots.forEach((slot) => {
      const own = slot.querySelector('input[type="radio"]:checked')?.value;
      slot.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const takenByOther = chosen.includes(radio.value) && radio.value !== own;
        radio.closest('[data-cc-swatch]')?.classList.toggle('is-taken', takenByOther);
      });
    });
  }

  #onShellChange(changed) {
    const checked = this.shellInputs.filter((input) => input.checked);
    if (checked.length > this.shellMax) {
      changed.checked = false;
    }
    this.shellInputs.forEach((input) => {
      const currentlyChecked = this.shellInputs.filter((i) => i.checked);
      input.disabled = !input.checked && currentlyChecked.length >= this.shellMax;
    });
    if (this.shellHiddenInput) {
      this.shellHiddenInput.value = this.shellInputs
        .filter((input) => input.checked)
        .map((input) => input.dataset.shellName)
        .join(', ');
    }
    this.#updateSummary();
  }

  #onNameInput(input) {
    const counter = input.parentElement?.querySelector('[data-cc-char-count]');
    if (counter) {
      const max = input.maxLength > 0 ? input.maxLength : null;
      counter.textContent = max ? `${input.value.length} / ${max}` : `${input.value.length}`;
    }
    this.#updateSummary();
  }

  #onThumbClick(thumb) {
    if (!this.galleryMain) return;
    this.galleryMain.src = thumb.dataset.ccThumb;
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
  }

  #updateSummary() {
    if (!this.summary) return;
    const lines = [];

    this.nameInputs.forEach((input) => {
      const label = input.dataset.ccName;
      lines.push(`${label}: ${input.value.trim() || '—'}`);
    });

    this.colorSlots
      .filter((slot) => !slot.hidden)
      .forEach((slot) => {
        const label = slot.dataset.ccColorLabel;
        const checked = slot.querySelector('input[type="radio"]:checked');
        lines.push(`${label}: ${checked ? checked.dataset.colorName : '—'}`);
      });

    const shells = this.shellInputs.filter((input) => input.checked).map((input) => input.dataset.shellName);
    lines.push(`Shells: ${shells.length ? shells.join(', ') : '—'}`);

    this.summary.innerHTML = lines.map((line) => `<span>${line}</span>`).join('');
  }
}

if (!customElements.get('couple-crate-personalize')) {
  customElements.define('couple-crate-personalize', CoupleCratePersonalize);
}
